/* ===========================================================
   Mundo3D — catálogo compartido de productos (datos reales de tumundo3d.cl)
   Las fotos siguen siendo placeholders; reemplaza emoji/desc por las reales.
   =========================================================== */
(function(){
  var P = [
    /* ---- Cocina ---- */
    {id:'caja-hermetica-para-queso', name:'Caja Hermética para Queso', cat:'Cocina', price:12990, emoji:'🧀', tag:'Más vendido', tagType:'hot', pop:99, rating:4.9, reviews:42,
      desc:'Mantiene tu queso fresco, sin olores y siempre a la mano en el refrigerador. Cierre hermético y tamaño justo para la repisa.'},
    {id:'saleros-star-wars', name:'Saleros Star Wars', cat:'Cocina', price:19990, emoji:'🧂', tag:'Edición especial', tagType:'new', pop:92, rating:4.8, reviews:21,
      desc:'Set de saleros coleccionables para fans de la saga. El detalle que conquista cualquier mesa.'},
    {id:'salero-pimentero-cactus', name:'Salero & Pimentero Cactus', cat:'Cocina', price:12990, emoji:'🌵', tag:'', tagType:'', pop:80, rating:4.7, reviews:18,
      desc:'Dúo de salero y pimentero con forma de cactus: práctico, simpático y con onda para tu cocina.'},
    /* ---- Ceniceros ---- */
    {id:'cenicero-homero-simpson', name:'Cenicero Homero Simpson', cat:'Ceniceros', price:6990, emoji:'🍩', tag:'Popular', tagType:'', pop:88, rating:4.8, reviews:35,
      desc:'Cenicero con diseño de Homero, fácil de limpiar. Un clásico simpático para tu espacio.'},
    {id:'cenicero-bad-bunny', name:'Cenicero Bad Bunny', cat:'Ceniceros', price:13990, emoji:'🐰', tag:'', tagType:'', pop:75, rating:4.7, reviews:14,
      desc:'Cenicero temático resistente, ideal para fans. Buen acabado y muy fácil de limpiar.'},
    {id:'cenicero-bitcoin', name:'Cenicero Bitcoin', cat:'Ceniceros', price:6990, emoji:'🪙', tag:'', tagType:'', pop:68, rating:4.6, reviews:11,
      desc:'Cenicero con el símbolo de Bitcoin. Compacto, sólido y con estilo cripto.'},
    {id:'cenicero-cabeza-de-sauron', name:'Cenicero Cabeza de Sauron', cat:'Ceniceros', price:7690, emoji:'👁️', tag:'', tagType:'', pop:64, rating:4.8, reviews:9,
      desc:'El ojo de Sauron vigilando tus cenizas. Una pieza con carácter para los fans del anillo.'},
    /* ---- Alcancías ---- */
    {id:'alcancia-diseno-de-gato', name:'Alcancía Diseño de Gato', cat:'Alcancías', price:14990, emoji:'🐱', tag:'Nuevo', tagType:'new', pop:78, rating:4.8, reviews:16,
      desc:'Alcancía con forma de gato para ahorrar con onda. Incluye tapón de silicona para sacar tus ahorros.'},
    {id:'alcancia-del-mandaloriano', name:'Alcancía del Mandaloriano', cat:'Alcancías', price:24990, emoji:'🪖', tag:'', tagType:'', pop:82, rating:4.9, reviews:23,
      desc:'Alcancía del Mando para fans de la galaxia. Gran nivel de detalle y buen tamaño.'},
    {id:'alcancia-diseno-de-arcoiris', name:'Alcancía Diseño de Arcoíris', cat:'Alcancías', price:19990, emoji:'🌈', tag:'', tagType:'', pop:60, rating:4.7, reviews:8,
      desc:'Alcancía arcoíris que alegra cualquier repisa mientras juntas tus ahorros.'},
    {id:'alcancia-diseno-de-cerdito', name:'Alcancía Diseño de Cerdito', cat:'Alcancías', price:12990, emoji:'🐷', tag:'', tagType:'', pop:66, rating:4.7, reviews:19,
      desc:'El clásico chanchito, reinventado en 3D. Tapón de silicona incluido.'},
    {id:'alcancia-diseno-r2-d2', name:'Alcancía Diseño R2-D2', cat:'Alcancías', price:34990, emoji:'🤖', tag:'Top fans', tagType:'hot', pop:85, rating:4.9, reviews:27,
      desc:'Alcancía R2-D2 con gran nivel de detalle. La favorita de los coleccionistas.'},
    {id:'alcancia-ironman', name:'Alcancía Ironman', cat:'Alcancías', price:24990, emoji:'🦾', tag:'', tagType:'', pop:79, rating:4.8, reviews:17,
      desc:'Alcancía de Ironman para ahorrar como un héroe. Acabado prolijo y resistente.'},
    {id:'alcancia-minecraft', name:'Alcancía Minecraft', cat:'Alcancías', price:14990, emoji:'⛏️', tag:'', tagType:'', pop:62, rating:4.6, reviews:12,
      desc:'Alcancía estilo Minecraft, perfecta para gamers que juntan monedas bloque a bloque.'},
    {id:'alcancia-rtx-3080', name:'Alcancía RTX 3080', cat:'Alcancías', price:16990, emoji:'🎮', tag:'', tagType:'', pop:58, rating:4.7, reviews:10,
      desc:'Alcancía con forma de tarjeta gráfica: ahorra para tu próximo upgrade gamer.'},
    /* ---- Organización ---- */
    {id:'bandeja-moderna-organizadora', name:'Bandeja Moderna Organizadora', cat:'Organización', price:7990, emoji:'🗄️', tag:'Más vendido', tagType:'hot', pop:90, rating:4.8, reviews:31,
      desc:'Bandeja moderna para llaves, monedas y tarjetas. Orden y estilo en la entrada de tu casa.'},
    {id:'caja-organizadora-de-cables', name:'Caja Organizadora de Cables', cat:'Organización', price:24990, emoji:'🔌', tag:'', tagType:'', pop:72, rating:4.7, reviews:15,
      desc:'Esconde cables y regletas en una caja prolija. Adiós al desorden bajo el escritorio.'},
    {id:'cargador-reloj-de-escritorio', name:'Cargador / Reloj de Escritorio', cat:'Organización', price:39990, emoji:'⏰', tag:'Nuevo', tagType:'new', pop:70, rating:4.8, reviews:9,
      desc:'Reloj de escritorio con soporte de carga para tu smartphone. Funcional y minimalista.'},
    /* ---- Personalizados ---- */
    {id:'bloques-llaveros-de-lego', name:'Bloques Llaveros para Colgador', cat:'Personalizados', price:1990, emoji:'🧱', tag:'Desde $1.990', tagType:'', pop:55, rating:4.6, reviews:13,
      desc:'Llaveros tipo bloque para tu colgador. Combínalos y ármalo a tu manera.'},
    {id:'arte-de-pared-auto', name:'Arte de Pared · Auto Personalizado', cat:'Personalizados', price:49990, from:true, emoji:'🚗', tag:'Personalizable', tagType:'new', pop:76, rating:5.0, reviews:7,
      desc:'Arte de pared con tu auto favorito, hecho a pedido. Tú eliges el modelo y los colores.'}
  ];

  var CATS = [
    {key:'Todos', em:'✨'},
    {key:'Cocina', em:'🍴'},
    {key:'Ceniceros', em:'🚬'},
    {key:'Alcancías', em:'🐷'},
    {key:'Organización', em:'🗄️'},
    {key:'Personalizados', em:'✏️'}
  ];

  // filament-style color options (3D print colors from the brand palette)
  var COLORS = [
    {key:'Negro', hex:'#2d2d2d'},
    {key:'Blanco', hex:'#f5f3ed'},
    {key:'Naranjo', hex:'#f78e2e'},
    {key:'Turquesa', hex:'#00bfa6'},
    {key:'Amarillo', hex:'#fded30'}
  ];

  window.M3D = {
    products: P,
    cats: CATS,
    colors: COLORS,
    fmt: function(n){ return '$'+n.toLocaleString('es-CL'); },
    byId: function(id){ return P.filter(function(x){ return x.id===id; })[0] || null; },
    countIn: function(key){ return key==='Todos' ? P.length : P.filter(function(p){ return p.cat===key; }).length; },
    related: function(p, n){
      n = n||6;
      var same = P.filter(function(x){ return x.cat===p.cat && x.id!==p.id; });
      var rest = P.filter(function(x){ return x.cat!==p.cat && x.id!==p.id; }).sort(function(a,b){ return b.pop-a.pop; });
      return same.concat(rest).slice(0, n);
    }
  };
})();
